



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { LearnItem } from '../../common/types';
import brandModule from '../../store/modules/brand.module';

@Component
export default class MenuCard extends Vue {
  @Prop() navigationItem!: LearnItem;

  @Prop({ default: '/learn/section' }) sectionRoot!: string;

  get brandSecondaryColor() {
    if (!brandModule.brand) { return; }
    return brandModule.brand.secondary_color;
  }
}
